import React from 'react';
import { Navigate } from 'react-router-dom';
import Routes from 'shared/enums/routes';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

type RouteRedirectorProps = {
  routeDomain: string;
};

const RouteRedirector = ({ routeDomain }: Readonly<RouteRedirectorProps>): React.JSX.Element => {
  const { hasRoutePermission } = usePermissionAuthorization();
  const domainRoutes = Object.keys(Routes).filter((key) => key.startsWith(routeDomain) && key !== routeDomain);

  const route = () => {
    for (const routeKey of domainRoutes) {
      const routePath = Routes[routeKey as keyof typeof Routes];
      if (hasRoutePermission(routePath)) {
        return routePath;
      }
    }
    return Routes.Default;
  };

  return <Navigate to={route()} replace />;
};

export default RouteRedirector;
